import { AnswerType } from '../../shared/enums/answer.enum';
import { Answer } from './answer.model';

export type ListQuestionAnswer = string[];

// Without this dynamic parameter AOT compiling will fail.
// @see https://angular.io/guide/angular-compiler-options#strictmetadataemit
// @dynamic
export class ListAnswer extends Answer {
  public answer: ListQuestionAnswer | undefined;

  constructor(id: string, type: AnswerType, answer?: ListQuestionAnswer) {
    super();
    this.id = id;
    this.type = type;
    this.answer = answer;
  }

  public static fromDto(dto: any): ListAnswer {
    return new ListAnswer(dto.id, dto.type, dto.answer);
  }
}
